/**
 * The read surface — the document list and the detail screen, and the «Libreta de direcciones» —
 * behind one guard.
 *
 * The sibling of `DecaSurface.tsx`, and deliberately a second file rather than one guard taking
 * the ability as a prop: the route tree is what gets read to find out who may reach what, and a
 * guard whose answer arrives from `router.tsx` moves that answer out of the tree and into its
 * wiring.
 *
 * Every signed-in role passes here, the two platform ones included — that is the whole of phase 4.
 * Creating, editing a draft, grouping and importing stay behind `DecaSurface` on `handlesDecas`,
 * which makes them structural. The writes on the screens here — a document's generate, complete,
 * modify, reassign and void, the list's void, the address book's entries and hides — are drawn by
 * each screen for `writeDecas` or `voidDecas` only, and it is that check, not this guard, that keeps
 * them from the platform roles.
 *
 * A null principal renders nothing rather than asking `landingPathFor`, for the same reason
 * `DecaSurface` does: that function's fallback is `/`, which is itself behind a guard.
 */

import { Navigate, Outlet } from '@tanstack/react-router'

import { useAuth } from '../app/auth.tsx'
import { landingPathFor } from '../deca/navigation.ts'
import { abilitiesFor } from '../deca/roles.ts'

export function DecaReadSurface() {
  const { principal } = useAuth()
  if (!principal) return null
  if (!abilitiesFor(principal).readsDecas) {
    return <Navigate to={landingPathFor(principal)} replace />
  }
  return <Outlet />
}
